import { i18n } from '@/i18n'
// icon 在这里
// https://element.eleme.cn/#/zh-CN/component/icon
export default [
  {
    title: i18n.t('menu.homePage'),
    icon: 'el-icon-s-home',
    route: { name: 'home' },
    can: []
  },
  {
    title: i18n.t('menu.userManagement'),
    icon: 'el-icon-user',
    children: [
      {
        title: i18n.t('model.user'),
        icon: 'el-icon-s-custom',
        route: { name: 'users.index' }
      },
      {
        title: i18n.t('model.adminUsersRole'),
        icon: 'el-icon-user-solid',
        route: { name: 'admin_users_roles.index' }
      },
      {
        title: i18n.t('model.role'),
        icon: 'el-icon-view',
        route: { name: 'roles.index' }
      },
      {
        title: i18n.t('model.passenger'),
        icon: 'el-icon-user-solid',
        route: { name: 'passengers.index' }
      },
    ]
  },
  {
    title: i18n.t('model.booking'),
    icon: 'el-icon-s-goods',
    route: { name: 'bookings.index' }
  },
  {
    title: i18n.t('menu.pageManagement'),
    icon: 'el-icon-s-management',
    children: [
      {
        title: i18n.t('model.page'),
        icon: 'el-icon-edit-outline',
        route: { name: 'pages.index' }
      }
    ]
  },
  {
    title: i18n.t('model.banner'),
    icon: 'el-icon-picture-outline',
    route: { name: 'banners.index' }
  },
  {
    title: i18n.t('model.activeStorageBlob'),
    icon: 'el-icon-upload',
    route: { name: 'active_storage/blobs.index' },
    can: ['active_storage_blobs.read']
  },
  {
    title: i18n.t('model.application'),
    icon: 'el-icon-menu',
    route: { name: 'applications.index' },
    can: ['applications.read_list_menu']
  },
  {
    title: i18n.t('model.application'),
    icon: 'el-icon-menu',
    route: { name: 'applications.show', params: { id: 'current' } },
    can: ['applications.read_detail_menu']
  },
  {
    title: i18n.t('menu.dataAnalysis'),
    icon: 'el-icon-view',
    children: [
      {
        title: i18n.t('wechatMiniProgram.analysis.userPortrait'),
        icon: 'el-icon-s-custom',
        route: { name: 'user_portrait' },
        can: 'data_analyses.user_portrait'
      },
      {
        title: i18n.t('wechatMiniProgram.analysis.visitPage'),
        icon: 'el-icon-document-copy',
        route: { name: 'visit_page' },
        can: 'data_analyses.visit_page'
      },
      {
        title: i18n.t('wechatMiniProgram.analysis.visitDistribution'),
        icon: 'el-icon-pie-chart',
        route: { name: 'visit_distribution' },
        can: 'data_analyses.visit_distribution'
      },
      {
        title: i18n.t('wechatMiniProgram.analysis.visitRetain'),
        icon: 'el-icon-s-data',
        route: { name: 'retain_info' },
        can: 'data_analyses.retain_info'
      },
      {
        title: i18n.t('wechatMiniProgram.analysis.visitTrend'),
        icon: 'el-icon-data-line',
        route: { name: 'visit_trend' },
        can: 'data_analyses.visit_trend'
      }
    ]
  },
  // 以下代码为generator插入代码的标记，请勿修改或删除
  // Generator menu
  {
    title: i18n.t('model.requestLog'),
    icon: 'el-icon-view',
    route: { name: 'request_logs.index' }
  },
  {
    title: i18n.t('model.route'),
    icon: 'el-icon-view',
    route: { name: 'routes.index' }
  },
  {
    title: i18n.t('model.station'),
    icon: 'el-icon-place',
    route: { name: 'stations.index' }
  },
  {
    title: i18n.t('model.localScenery'),
    icon: 'el-icon-picture',
    route: { name: 'local_sceneries.index' }
  },
  {
    title: i18n.t('model.frequentlyAskedQuestion'),
    icon: 'el-icon-question',
    route: { name: 'frequently_asked_questions.index' }
  },
  {
    title: i18n.t('model.hotWord'),
    icon: 'el-icon-search',
    route: { name: 'hot_words.index' }
  },
  {
    title: i18n.t('model.operationRecord'),
    icon: 'el-icon-picture-outline',
    route: { name: 'operation_records.index' }
  }
];
